import moment from 'moment-timezone';

export const TIMEZONE_DEFAULT = 'America/Los_Angeles';

export const getTimeZone = (timezone) => timezone || TIMEZONE_DEFAULT;

export const getUserTimeZone = () => getTimeZone(moment.tz.guess());
